import type { PermissionCategory } from "components/team/Roles/helpers/customRolesApi";
import {
  PERMISSION_CATEGORIES_GET_REQUEST,
  PERMISSION_CATEGORIES_GET_REQUEST_SUCCESS,
  PERMISSION_CATEGORIES_GET_REQUEST_FAILURE,
  PERMISSION_CATEGORIES_GET_RESET,
  PermissionCategoriesGetAction,
} from "./permissionCategoriesGetActions";

export interface PermissionCategoriesGetState {
  loaded: boolean;
  loading: boolean;
  error: Error | null;
  data: PermissionCategory[] | null;
}

const initialState: PermissionCategoriesGetState = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
};

export default function permissionCategoriesGetReducer(
  state: PermissionCategoriesGetState = initialState,
  action: PermissionCategoriesGetAction
): PermissionCategoriesGetState {
  switch (action.type) {
    case PERMISSION_CATEGORIES_GET_REQUEST:
      // Don't blank `data` here so the catalog stays visible during a refetch
      // (e.g. after tenant switch). Consumers can read `loading` to render
      // a spinner overlay if they want.
      return { ...state, loading: true, error: null };
    case PERMISSION_CATEGORIES_GET_REQUEST_SUCCESS:
      return {
        loading: false,
        loaded: true,
        error: null,
        data: action.data,
      };
    case PERMISSION_CATEGORIES_GET_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case PERMISSION_CATEGORIES_GET_RESET:
      return { ...initialState };
    default:
      return state;
  }
}
